module.exports = __webpack_public_path__ + "static/img/logo.829c833.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/elephant/logo.png
// module id = IYQK
// module chunks = 1